export const formatPhoneNumber = (phoneNumber) => {
  if (typeof phoneNumber === 'string' && phoneNumber.length) {
    return phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6);
  }
  return undefined;
};
